var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"tsa-environmentCheck"},[_c('div',{staticClass:"mask"}),_c('div',{staticClass:"content"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/environment_ing.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }